import { cn } from '~/shadcn/lib/utils'

type Props = {
  children: React.ReactNode
  className?: string
}
function InvestmentAttribute({ children, className }: Props) {
  return (
    <div
      className={cn(
        'flex flex-row justify-between items-center border-border-strong border-b',
        className
      )}>
      {children}
    </div>
  )
}

export { InvestmentAttribute }
